<template>
  <v-card>
    <v-form
      @submit.prevent="onUpdate"
      lazy-validation
      ref="form"
      v-model="isValidForm"
    >
      <template v-if="!$apollo.loading">
        <div class="sticky top-0">
          <v-card-title>Förfrågning</v-card-title>
        </div>
        <v-divider />
        <div class="overflow-y-auto p-4" :style="{ height: tableHeight }">
          <v-form>
            <v-row>
              <v-col>
                <v-text-field
                  label="UUID"
                  v-model="inquiry.uuid"
                  disabled
                ></v-text-field>
                <v-text-field
                  label="Förnamn"
                  v-model="model.first_name"
                  required
                  :disabled="isInquririesUndisclosed"
                  :rules="[validationRules.required]"
                ></v-text-field>
                <v-text-field
                  label="Efternamn"
                  v-model="model.last_name"
                  required
                  :disabled="isInquririesUndisclosed"
                  :rules="[validationRules.required]"
                ></v-text-field>
                <v-text-field
                  label="Telefonnummer"
                  :rules="[validationRules.phone]"
                  :disabled="isInquririesUndisclosed"
                  v-model="model.phone"
                ></v-text-field>
                <v-text-field
                  label="Epost"
                  required
                  :rules="[validationRules.required, validationRules.email]"
                  :disabled="isInquririesUndisclosed"
                  v-model="model.email"
                ></v-text-field>

                <v-select
                  item-text="name"
                  item-value="uuid"
                  @change="() => (model.category_uuid = null)"
                  :items="categoryGroups"
                  v-model="category_group_uuid"
                  :disabled="isInquririesUndisclosed"
                  :rules="[validationRules.required]"
                  label="Kategori"
                ></v-select>
                <v-select
                  item-text="name"
                  item-value="uuid"
                  :items="filteredSubCategories"
                  v-model="model.category_uuid"
                  :disabled="isInquririesUndisclosed"
                  :rules="[validationRules.required]"
                  label="Underkategori"
                ></v-select>
                <v-textarea
                  label="Beskrivning föremål"
                  rows="4"
                  placeholder="Kännetecken, färg, modell, serienummer. skick etc."
                  :disabled="isInquririesUndisclosed"
                  v-model="model.description"
                ></v-textarea>
                <v-text-field
                  v-model="lost_at"
                  type="datetime-local"
                  label="Tid föremålet förlorades"
                  disabled
                ></v-text-field>
                <v-radio-group
                  v-model="model.transportation_type_uuid"
                  :disabled="isInquririesUndisclosed"
                  mandatory
                >
                  <p>Färdsätt</p>
                  <v-radio
                    :label="transportationType.name"
                    :value="transportationType.uuid"
                    v-for="(transportationType, $i) in Object.values(
                      transportationTypes,
                    )"
                    :key="$i"
                  ></v-radio>
                </v-radio-group>
                <v-text-field
                  label="Linje/tågnummer"
                  :disabled="isInquririesUndisclosed"
                  v-model="model.transportation_number"
                ></v-text-field>
                <v-textarea
                  label="Yttligare information"
                  placeholder="Ex. Sträcka, hållplats"
                  :disabled="isInquririesUndisclosed"
                  rows="4"
                  v-model="model.transportation_information"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </div>
        <v-divider />
        <v-card-actions class="p-4">
          <v-spacer />
          <v-dialog v-model="showResolveConfirm" width="500">
            <template v-slot:activator="{ on }">
              <v-btn
                :disabled="isInquririesUndisclosed"
                :text="isInquririesUndisclosed"
                color="primary"
                v-on="on"
              >
                <v-icon v-if="isInquririesUndisclosed" left>mdi-check</v-icon>
                <v-icon v-else left>mdi-clipboard-arrow-down</v-icon>
                {{ !status ? 'Utlämna' : 'Utlämnad' }}
              </v-btn>
            </template>
            <InquiriesResolveConfirm
              @close="showResolveConfirm = false"
              @confirm="resolveInquiry"
              v-if="showResolveConfirm"
            />
          </v-dialog>

          <v-btn
            type="submit"
            color="primary"
            v-if="!isInquririesUndisclosed"
            :disabled="!isFormChanges"
            :loading="updating"
            >Uppdatera</v-btn
          >
        </v-card-actions>
      </template>
    </v-form>
  </v-card>
</template>

<script>
import GET_CATEGORIES from '@/gql/categories/queries/GetCategories.gql'
import GET_CATEGORY_GROUPS from '@/gql/categoryGroups/queries/GetCategoryGroups.gql'
import GET_TRANSPORTATION_TYPES from '@/gql/transportationTypes/queries/GetTransportationTypes.gql'
import InquiriesResolveConfirm from './InquiriesResolveConfirm'
import UPDATE_INQUIRY from '@/gql/inquiries/mutations/UpdateInquiry.gql'
import { get } from 'vuex-pathify'
import { validationRules } from '@/common/validationRules'
import { format } from 'date-fns'
import { tableHeight } from '@/mixins/tableHeight'
import isEqual from 'lodash.isequal'

export default {
  name: 'InquiriesForm',

  components: { InquiriesResolveConfirm },

  mixins: [tableHeight(230)],

  props: {
    inquiry: Object,
  },

  data() {
    return {
      showResolveConfirm: false,
      isValidForm: true,
      updating: false,
      validationRules,
      category_group_uuid: null,
      lost_at: null,
      origModel: {},
      status: null,
      model: {
        first_name: null,
        last_name: null,
        email: null,
        phone: null,
        description: null,
        transportation_type_uuid: null,
        transportation_number: null,
        transportation_information: null,
        category_uuid: null,
      },
    }
  },

  created() {
    for (let prop in this.model) {
      this.category_group_uuid = this.inquiry.category.category_group.uuid
      this.model[prop] = this.inquiry[prop]
      this.status = this.inquiry.status
      this.origModel[prop] = this.inquiry[prop]
      this.lost_at = format(
        new Date(this.inquiry.lost_at),
        "yyyy-MM-dd'T'HH:mm",
      )
    }
  },

  computed: {
    owner: get('app/owner'),

    isInquririesUndisclosed() {
      return !!this.status
    },

    isFormChanges() {
      return !isEqual(this.model, this.origModel)
    },

    filteredSubCategories() {
      return (this.categories || []).filter(
        ({ category_group_uuid }) =>
          category_group_uuid === this.category_group_uuid,
      )
    },
  },

  apollo: {
    transportationTypes: {
      query: GET_TRANSPORTATION_TYPES,
    },

    categoryGroups: {
      query: GET_CATEGORY_GROUPS,
    },

    categories: {
      query: GET_CATEGORIES,
    },
  },

  methods: {
    resolveInquiry() {
      this.status = 1
      this.updateInquiry({ status: this.status })
      this.showResolveConfirm = false
    },

    async onUpdate() {
      const isValid = await this.$refs.form.validate()
      if (!isValid) return
      this.updating = true
      await this.updateInquiry(this.model)
      this.origModel = Object.assign({}, this.model)
      this.updating = false
    },

    updateInquiry(payload) {
      return this.$apollo.mutate({
        mutation: UPDATE_INQUIRY,
        variables: {
          payload,
          uuid: this.$route.params.uuid,
        },
      })
    },
  },
}
</script>
